import { render, staticRenderFns } from "./ImpresosCard.vue?vue&type=template&id=6aa0c45c"
import script from "./ImpresosCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpresosCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports